import { ExerciseType } from "../../components/heading/heading";
import { SuggestedTime } from "../../components/badges/suggested_time";
import { Level } from "../../components/badges/level";
import React from "react";
import { Col } from "reactstrap";
import {
  AccountType,
  exerciseType,
} from "../../components/constants/constants";
import { Timer } from "../../components/timer/timer";

export const QuizDescription = ({
  isReview,
  data,
  isStopTimer,
  setIsStopTimer,
  timer,
  Contentedit,
  edit_template,
}) => {
  let p_size = "p-2";
  if(edit_template === "true")
  {
    p_size = "p-1";
  }
  let class_name = "exercise-bg-grammer";
  if (data.task_type === exerciseType.GRAMMAR_TASK) {
    class_name = "exercise-bg-grammer";
  } else if (data.task_type === exerciseType.WRITING_TASK) {
    class_name = "exercise-bg-writing";
  } else if (data.task_type === exerciseType.VOCABULARY_TASK) {
    class_name = "exercise-bg-vocab";
  } else if (data.task_type === exerciseType.PRONUNCIATION_TASK || data.task_type === exerciseType.SPEAKING_TASK) {
    class_name = "exercise-bg-pronunciation";
  } else if (data.task_type === exerciseType.READING_TASK) {
    class_name = "exercise-bg-reading";
  } else if (data.task_type === exerciseType.LISTENING_TASK) {
    class_name = "exercise-bg-listening";
  }
  return (
    <div
      className={`px-4 ${p_size} ${class_name} row rounded-header border border-bottom-0`}
    >
      <div className="col-xl-4 col-xxl-4 col-lg-4 col-md-4  col-sm-12 px-1 align-self-center">
      <Col className="d-flex align-items-center">
        <div className="sm-display col-12">
          <div className="col-5 d-flex">
            {!data?.hide_task_level && (
              <div className="overlap-parent me-2">
                {data.task_levels &&
                data.task_levels.map((level, index) => (
                  <Level key={index} level={level.value} edit_template={edit_template} />
                ))}
              </div>
            )}
            <div className="align-self-center">
              <ExerciseType edit_template={edit_template} title={data.task_type.split(" ")[0]} />
            </div>
          </div>
          {data.user_type === AccountType.STUDENT ? (
          <div className="col-7 text-end">
              <span className="p-1 text-nowrap">
                <b>
                  {data && timer && (
                    <Timer
                      edit_template={edit_template}
                      isStopTimer={
                        data.user_type !== AccountType.STUDENT || isReview
                          ? true
                          : isStopTimer
                      }
                      nature_of_test={data.type}
                      totalTimeInSeconds={data?.assignment_allowed_time}
                      localSpentTime={timer}
                      onStop={(props) => {
                        // alert("Times up");
                        setIsStopTimer(false);
                        // creatQuizDataAndSubmit();
                      }}
                    />
                  )}
                </b>
              </span>
          </div>
          ): null}
        </div>
        <div className="lg-display">
        {!data?.hide_task_level && (
          <div className="overlap-parent me-2">
            {data.task_levels &&
              data.task_levels.map((level, index) => (
                <Level edit_template={edit_template} key={index} level={level.value} />
              ))}
          </div>
        )}
          <div>
            <ExerciseType edit_template={edit_template} title={data.task_type.split(" ")[0]} />
          </div>
        </div>
      </Col>
      </div>
      <div className="col-xl-8 col-xxl-8 col-lg-8 col-md-8 col-sm-12 d-flex lg-display px-1">
      {data.user_type === AccountType.STUDENT ? (
          <div className="col-12 d-flex">
            <Col md className="col-6 timer-text align-self-center center">
              <span className="p-1 text-nowrap">
                <b>
                  {data && timer && (
                    <Timer
                      edit_template={edit_template}
                      isStopTimer={
                        data.user_type !== AccountType.STUDENT || isReview
                          ? true
                          : isStopTimer
                      }
                      nature_of_test={data.type}
                      totalTimeInSeconds={data?.assignment_allowed_time}
                      localSpentTime={timer}
                      onStop={(props) => {
                        // alert("Times up");
                        setIsStopTimer(false);
                        // creatQuizDataAndSubmit();
                      }}
                    />
                  )}
                </b>
              </span>
            </Col>
            <Col md className="col-6 center justify-content-end">
              <SuggestedTime edit_template={edit_template} time={data?.assignment_allowed_time} Contentedit={Contentedit} data={data} />
            </Col>
          </div>
      ): null}
      </div>

      {/* <Col md className="center">
        <NumberOfQuestions questions={size(data.questions)} />
      </Col>
      <Col md className="center">
        <div className="d-flex">
        
          <Level
            level={
              join(data.task_levels.map(values),",")
            }
          />
        </div>
      </Col> */}
    </div>
  );
};
